var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":'pgwSlideshow' + _vm.image.imageId}},[_c('li',[_c('img',{staticClass:"image-scale",attrs:{"id":_vm.image.imageId,"src":_vm.getImageSrc(_vm.image),"alt":_vm.image.alt,"data-description":_vm.image.dataDescription}})])])}
var staticRenderFns = []

export { render, staticRenderFns }